import React, { Component } from 'react'
import { Modal } from 'hljd'
import { observer } from 'mobx-react'
@observer
export default class extends Component {
  render() {
    const { infoModalVisible, operateModal } = this.props.store
    return (
      <Modal
        visible={infoModalVisible}
        footer={null}
        width={600}
        onCancel={operateModal('infoModalVisible')}
      >
        <div style={{ padding: '60px 56px 58px' }}>
          <div
            style={{
              color: '#fff',
              fontSize: 16,
              lineHeight: '60px',
              width: 200,
              height: 60,
              backgroundColor: '#448afc',
              borderRadius: 2,
              margin: '0 auto 40px',
              textAlign: 'center',
              cursor: 'pointer'
            }}
            onClick={operateModal('listModalVisible', 'infoModalVisible')}
          >
            微传单+制作（推荐）
          </div>
          <div style={{ fontSize: 16, color: '#666' }}>
            全新改版的活动创建工具，简单快捷的创建流程，完美支持微信、微博、抖音等外部分享，亦可用于婚礼纪平台推广，添加聚客宝审核通过后可尽快安排上线。
          </div>
        </div>
      </Modal>
    )
  }
}
